import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { RefinamientosapiService } from '../../../services/refinamientosapi.service';
import { Store } from '@ngrx/store';
import { UserState } from '../../../redux/reducers/user.reducer';
import { LoadingState } from '../../../redux/reducers/loading.reducer';
import { BaseArchivo } from '../../../models/Archivocaso';
import { Refinamiento, EstadoRefinamiento } from '../../../models/Refinamiento';
import { showLoading, hideLoading } from '../../../redux/actions/loading.actions';
import { userHasRole } from '../../../models/User';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verformrefinamiento',
  templateUrl: './verformrefinamiento.component.html',
  styleUrls: ['./verformrefinamiento.component.scss'],
  standalone: false
})
export class VerformrefinamientoComponent implements OnInit {

  isAdmin = false;
  isDoctor = false;

  archivos: BaseArchivo[] = [];

  refinamiento: Refinamiento = {
    id: 0,
    motivoEnvio: "",
    motivoOtroExplique: "",
    nroAlineacionSuperior: "", nroAlineacionInferior: "", caso_id: 0, status: EstadoRefinamiento.PAGO_FINAL_REFINAMIENTO_COMPROBADO,
    pregunta1Arcos: "",
    pregunta2RestriccionDental: '',
    pregunta2dientes: "",
    pregunta3Aditamentos: '',
    pregunta3dientes: "",
    pregunta4aMantenerI: '',
    pregunta4aMantenerD: '',
    pregunta4bMejorarRelacionI: '',
    pregunta4bMejorarRelacionD: '',
    pregunta4cCorreccionI: '',
    pregunta4cCorreccionD: '',
    pregunta4dOpcionMovimiento: "",
    pregunta4daDesgaste: '',
    pregunta4dbSimulacion: '',
    pregunta4dcDistalizacion: '',
    pregunta4deCortes: '',
    pregunta4deElasticoS: '',
    pregunta4deElasticoI: '',
    pregunta4deElasticoV: '',
    pregunta4deElasticoL: '',
    pregunta4deBotonS: '',
    pregunta4deBotonI: '',
    pregunta4deBotonV: '',
    pregunta4deBotonL: '',
    pregunta4dObservacion: '',
    pregunta5aOverjetMostrar: '',
    pregunta5bOverjetMejorar: '',
    pregunta6: "",
    pregunta6b: "",
    pregunta6c: "",
    pregunta6caInstruirSolamenteSup: "",
    pregunta6caInstruirSolamenteInf: "",
    pregunta6baExtruirSolamenteInf: "",
    pregunta6baExtruirSolamenteSup: "",
    pregunta6bbExtruireInstruirInf: "",
    pregunta6bbExtruireInstruirSup: "",
    pregunta6cbInstruiryExtruirSup: "",
    pregunta6cbInstruiryExtruirInf: "",
    pregunta6dOtroObs: '',
    pregunta7: "",
    pregunta7bModificarLineaMediaSup: "",
    pregunta7bModificarLineaMediaInf: "",
    pregunta7bbObservacion: '',
    pregunta8: '',
    pregunta8bOtro: '',
    pregunta8baApinamiento: "",
    pregunta8bbVestibularizar: "",
    pregunta8bcDipAnterior: "",
    pregunta8bdDipPosteriorDer: "",
    pregunta8beDipPosteriorIzq: "",
    pregunta8caApinamiento: "",
    pregunta8cbVestibularizar: "",
    pregunta8ccDipAnterior: "",
    pregunta8cdDipPosteriorDer: "",
    pregunta8ceDipPosteriorIzq: "",
    pregunta8dExtraccion: '',
    pregunta8ddientes: "",
    pregunta9ObservacionesComplementarias: '',
    created_at: '',
    updated_at: ''
  };

  error: boolean;
  userData$: Observable<any>;
  constructor(
    private actRoute: ActivatedRoute,
    private apiCaso: RefinamientosapiService,
    private store: Store<{ user: UserState }>,
    private storeLoading: Store<LoadingState>
  ) {

    this.userData$ = this.store.select(store => store.user.userData);
    this.actRoute.params.subscribe(data => {
      if (data.id) {
        // console.log(data.id);
        this.getCaso(data.id);
      } else {
        // this.fechaNacimientoObject = this.parserFormatter.parse(this.PlanTratamiento.fechaNacimiento);
      }
    });
  }

  getCaso(id: string) {
    this.storeLoading.dispatch(showLoading({ loadingText: "Obteniendo datos del refinamiento..." }));

    this.apiCaso.getRefinamiento(id).subscribe(data => {
      if (data) {
        this.refinamiento = data;
        this.archivos = data.archivos;

        this.error = false;
      } else {
        this.error = true;
      }

      this.storeLoading.dispatch(hideLoading());
    });
  }
  ngOnInit() {
    this.userData$.subscribe(data => {
      this.checkAdminPermission(data);
    })
  }

  checkAdminPermission(userData) {
    this.isAdmin = userHasRole('Admin', userData);
    this.isDoctor = userHasRole('Doctor', userData);
  }
  getImageUrl(file: string) {
    return environment.baseUrl + '/files/archivosrefinamiento/' + this.refinamiento.id + '/' + file + '.jpg';
  }
  archivoExiste(identificador: string) {
    return this.archivos.filter(archivo => archivo.identificador == identificador).length > 0;
  }
}
